import React from "react";
import editIconSrc from "../../assets/images/icons/edit-01.svg";

const DEFAULT_SIZE = 14;
const INVERSE_FILTER = "brightness(0) invert(1)";

const VARIANT_CLASS = {
  default: "edit-icon--default",
  inverse: "edit-icon--inverse",
  auto: "edit-icon--auto",
};

function resolveSize(sizeProp, style) {
  if (sizeProp != null) {
    const parsed =
      typeof sizeProp === "number" ? sizeProp : parseInt(String(sizeProp), 10);
    return Number.isFinite(parsed) ? parsed : DEFAULT_SIZE;
  }

  const fontSize = style?.fontSize;
  if (fontSize != null) {
    const parsed =
      typeof fontSize === "number" ? fontSize : parseInt(String(fontSize), 10);
    return Number.isFinite(parsed) ? parsed : DEFAULT_SIZE;
  }

  return DEFAULT_SIZE;
}

function resolveVariant(variantProp, style) {
  if (variantProp && variantProp !== "auto") {
    return variantProp;
  }

  const color = String(style?.color || "").toLowerCase().trim();
  if (
    color === "white" ||
    color === "#fff" ||
    color === "#ffffff" ||
    color.includes("255, 255, 255") ||
    color.includes("255,255,255")
  ) {
    return "inverse";
  }

  return "auto";
}

const EditIcon = ({
  size,
  style,
  className,
  variant: variantProp = "auto",
  onClick,
  alt = "Edit",
  ...rest
}) => {
  const iconSize = resolveSize(size, style);
  const { fontSize, color, ...restStyle } = style || {};
  const variant = resolveVariant(variantProp, style);
  const combinedClassName = ["edit-icon", VARIANT_CLASS[variant], className]
    .filter(Boolean)
    .join(" ");

  return (
    <img
      src={editIconSrc}
      alt={alt}
      className={combinedClassName}
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
        cursor: restStyle.cursor ?? (onClick ? "pointer" : undefined),
        filter: variant === "inverse" ? INVERSE_FILTER : undefined,
        ...restStyle,
      }}
      onClick={onClick}
      {...rest}
    />
  );
};

export default EditIcon;
